import './titleJacketImage.less';
import { getTitleJacketUri } from './../util';

function TitleJacketImage({ product, height, doNotPadRight }) {
	if (product) {
		const uri = getTitleJacketUri(product);
		if (uri) {
			return !height ? (
				<div style={{ position: 'relative' }}>
					<img
						alt={product.name}
						style={{
							width: !doNotPadRight ? '90%' : '100%',
							opacity: '0.2',
						}}
						title={product.name}
						src={uri}
					/>
					<img
						alt={product.name}
						style={{
							width: !doNotPadRight ? '74%' : '90%',
							position: 'absolute',
							left: '5%',
							top: '5%',
							boxShadow: '0 0 4px #6b6868',
						}}
						title={product.name}
						src={uri}
					/>
				</div>
			) : (
				<div style={{ position: 'relative' }}>
					<img
						alt={product.name}
						style={{
							height: `${height}px`,
							opacity: '0.2',
						}}
						title={product.name}
						src={uri}
					/>
					<img
						alt={product.name}
						style={{
							height: `${height * 0.82}px`,
							position: 'absolute',
							left: '8%',
							top: '8%',
							boxShadow: '0 0 4px #6b6868',
						}}
						title={product.name}
						src={uri}
					/>
				</div>
			);
		} else {
			return (
				<div
					className="no-jacket-scroller-outer"
					style={{
						height: `${height - 2}px`,
						width: `${height * 0.66}px`,
					}}>
					<div
						className={`no-jacket-scroller-inner${
							height <= 50 ? '-small' : ''
						}`}
						style={{
							height: `${height}px`,
							maxWidth: `${height * 1.1}px`,
						}}>
						<span className="bold">
							{product ? product.name : 'Unknown Title'}
						</span>
					</div>
				</div>
			);
		}
	} else {
		return <div></div>;
	}
}

export default TitleJacketImage;
